/* eslint-disable no-underscore-dangle */

import {ACCESS_STATUS as accessStatuses} from '../deviceConstants';

class AuditStatusColumnRenderer {
  constructor(model) {
    this._model = model;
    this._rootElem = document.createElement('access-status-column');
    this._rootElem.component = this._model;

    this._accessStatuses = accessStatuses;
    this._statusIcon = document.createElement('span');

    this._registerListeners();
    this.render();
  }

  /********************************************/
  /* START PRIVATE COMPONENT RENDERER METHODS */
  /********************************************/

  _shutdown() {
    return new Promise((resolve /*,reject*/) => {
      this._unregisterListeners();

      this._statusIcon.remove();
      this._statusIcon = undefined;
      this._accessStatuses = undefined;

      this._model = undefined;
      this._rootElem.remove();
      this._rootElem = undefined;
      resolve();
    });
  }

  _registerListeners() {
    this._model.on('AuditStatus', (this._onAuditStatus = this._onAuditStatus.bind(this)));
  }

  _unregisterListeners() {
    this._model.removeAllListeners('AuditStatus');
  }

  /*******************************************/
  /* END PRIVATE COMPONENT RENDERER METHODS  */
  /* START PUBLIC COMPONENT RENDERER METHODS */
  /*******************************************/

  /**
   * Stateless method to completely rebuild this component from the _rootElem down.
   * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
   * Promise is returned the caller will assume the Renderer has completed rendering.
   */

  render() {
    this._setAccessStatus(this._model.getAccessStatus());
    return Promise.resolve();
  }

  get rootElement() {
    return this.getRootElement();
  }

  getRootElement() {
    return this._rootElem;
  }

  get model() {
    return this.getModel();
  }

  getModel() {
    return this._model;
  }

  /*******************************************/
  /* END COMPONENT RENDERER METHODS          */
  /* START HANDLER METHODS                   */
  /*******************************************/

  _onAuditStatus(newVal) {
    this._setAccessStatus(newVal);
  }

  /*******************************************/
  /* END HANDLER METHODS                     */
  /* START PRIVATE API METHODS               */
  /*******************************************/

  _setAccessStatus(newVal = 'UNKNOWN') {
    const auditStatus = this._accessStatuses[newVal];
    if (auditStatus) {
      this._updateIcon(auditStatus);
      if (!this._rootElem.contains(this._statusIcon)) {
        this._rootElem.innerHTML = '';
        this._rootElem.appendChild(this._statusIcon);
      }
    } else {
      this._rootElem.innerHTML = newVal;
    }
  }

  _updateIcon(icon) {
    this._statusIcon.removeAttribute('class');
    this._statusIcon.classList.add(`g-icon-access-${icon.toLowerCase()}`);
  }

  /*******************************************/
  /*  END PRIVATE API METHODS                */
  /*******************************************/
}

export default AuditStatusColumnRenderer;
